export const LOADING_FACTOR_NAME = "LOADING_FACTOR_NAME";
export const SAVE_LOADING_FACTOR_NAME = "SAVE_LOADING_FACTOR_NAME";
export const GET_FACTOR_NAME = "GET_FACTOR_NAME";
export const FORM_FAIL = "FORM_FAIL";
export const FACTOR_FAIL = "FACTOR_FAIL";
export const LOADING_FACTOR_NAME_BY_ID = "LOADING_FACTOR_NAME_BY_ID";
export const GET_FACTOR_NAME_BY_ID = "GET_FACTOR_NAME_BY_ID";

